import clsx from 'clsx';
import React from 'react';

import IconProTagArticle from '@components/Images/Rebranding/IconProTagArticle';
import LazyImgixImage from '@components/LazyImgixImage';
import { getArticleImgSrc } from '@utils/images';

import ArticleDetails from '../ArticleDetails';
import Header from '../Header';
import PictureCaption, { PICTURE_CAPTION_CLASSES } from '../PictureCaption';
import { ThemeViewsProps } from '../interfaces';
import Content from './Content';
import Video from './Video';

const Standard = ({
  article: {
    addendum,
    advertisement,
    authors,
    commentsCount,
    commenters,
    freeBlurb,
    fullText,
    highlight,
    id,
    isPro,
    media,
    pickups,
    picture,
    pictureCaption,
    pictureLink,
    publishedAt,
    scriptList,
    subTitle,
    takeaway,
    title,
  },
  canShareArticle,
  canViewFullArticle,
  canViewComments,
  clipperProps,
  env,
  isSEOBotAndArticleIsNotFree,
  midArticleUnitType,
  mostPopularArticles,
  newsletterId,
  relatedArticles,
  relatedEvent,
  suggestedAiPrompts,
  audioActive,
  setAudioActive,
}: ThemeViewsProps) => {
  const Picture = (
    <LazyImgixImage
      alt={title}
      className="article-hero-image aspect-[16/9] h-auto w-full"
      src={getArticleImgSrc(id, picture, env)}
      visibleByDefault
      wrapperClassName="!flex"
    />
  );

  return (
    <div className="px-16 sm:px-28">
      <div className="relative m-auto max-w-container-lg">
        <div className="mb-24 flex flex-col items-center justify-between sm:mb-48 lg:mb-72">
          <div className="z-10 mb-32 w-full flex-1 sm:mb-48 lg:mb-32">
            <Header highlight={highlight} title={title} subTitle={subTitle} />
          </div>
          {!media ? (
            <figure className="relative m-0 aspect-[16/9] w-full" aria-labelledby="caption-text">
              {isPro && (
                <IconProTagArticle className="absolute right-0 top-0 w-[65px] sm:w-[119px]" />
              )}
              {pictureLink ? <a href={pictureLink}>{Picture}</a> : Picture}
              <PictureCaption className="block !w-full" pictureCaption={pictureCaption} />
            </figure>
          ) : (
            <Video canViewFullArticle={canViewFullArticle} media={media} />
          )}
        </div>
        <div
          className={clsx('relative m-auto lg:max-w-[1060px] xl:max-w-container-lg', {
            'mb-80 sm:mb-112': !!midArticleUnitType && canViewFullArticle,
          })}
        >
          <div className="flex flex-col-reverse md:flex-row md:gap-72 xl:gap-112">
            <div className="z-10 flex-1">
              <div className="mb-40 sm:mb-48 md:mb-64">
                <ArticleDetails
                  authors={authors}
                  commentsCount={commentsCount}
                  commenters={commenters}
                  publishedAt={publishedAt}
                  canShareArticle={canShareArticle}
                  articleId={id}
                  audioActive={audioActive}
                  setAudioActive={setAudioActive}
                />
              </div>
            </div>
            <div
              className={clsx(
                PICTURE_CAPTION_CLASSES,
                'hidden md:block md:w-[195px] md:flex-shrink-0 lg:w-[260px]'
              )}
            />
          </div>
          <Content
            addendum={addendum}
            advertisement={advertisement}
            authors={authors}
            canViewFullArticle={canViewFullArticle}
            canViewComments={canViewComments}
            clipperProps={clipperProps}
            commentsCount={commentsCount}
            env={env}
            freeBlurb={freeBlurb}
            fullText={fullText}
            highlight={highlight}
            id={id}
            isSEOBotAndArticleIsNotFree={isSEOBotAndArticleIsNotFree}
            midArticleUnitType={midArticleUnitType}
            mostPopularArticles={mostPopularArticles}
            newsletterId={newsletterId}
            pickups={pickups}
            relatedArticles={relatedArticles}
            relatedEvent={relatedEvent}
            scriptList={scriptList}
            suggestedAiPrompts={suggestedAiPrompts}
            takeaway={takeaway}
            audioActive={audioActive}
          />
        </div>
      </div>
    </div>
  );
};

export default Standard;
